import React, {useState, Suspense, lazy} from 'react'
import './App.css'
import ErrorBoundary from './components/common/ErrorBoundary'
import { WebSocketProvider } from './contexts/WebSocketContext'
import NotificationToast from './components/common/NotificationToast'
import { getToken, setToken as storeToken, removeToken } from './utils/tokenStorage'
import Loader from './components/Loader'

// Lazy load components for code splitting
const Auth = lazy(() => import('./components/auth/Auth'))
const Dashboard = lazy(() => import('./components/dashboard'))
const TestSuitesPage = lazy(() => import('./components/test-suites/TestSuitesPage'))
const ApiTesterScreen = lazy(() => import('./components/apiTester'))
const ReportsScreen = lazy(() => import('./components/reports'))
const Settings = lazy(() => import('./components/settings').then(module => ({ default: module.Settings })))
const SecurityScannerPage = lazy(() => import('./components/security'))

function App(): React.ReactElement {
  const [token, setToken] = useState<string | null>(
    getToken(),
  )
  const [activeTab, setActiveTab] = useState<
    'dashboard' | 'tester' | 'suites' | 'reports' | 'settings' | 'security'
  >('dashboard')

  const handleLogin = (newToken: string) => {
    storeToken(newToken)
    setToken(newToken)
  }

  const handleLogout = () => {
    removeToken()
    setToken(null)
  }

  const handleNavigate = (
    tab: 'dashboard' | 'tester' | 'suites' | 'reports' | 'settings' | 'security',
  ) => {
    setActiveTab(tab)
  }
  return (
    <ErrorBoundary>
      <div className="App">
        <Suspense fallback={<Loader />}>
          {token ? (
            <WebSocketProvider>
              <NotificationToast />
              {activeTab === 'dashboard' && (
                <ErrorBoundary>
                  <Dashboard
                    onNavigate={handleNavigate as any}
                    onLogout={handleLogout}
                  />
                </ErrorBoundary>
              )}
              {activeTab === 'tester' && (
                <ErrorBoundary>
                  <ApiTesterScreen
                    onNavigate={handleNavigate as any}
                    onLogout={handleLogout}
                  />
                </ErrorBoundary>
              )}
              {activeTab === 'suites' && (
                <ErrorBoundary>
                  <TestSuitesPage
                    onNavigate={handleNavigate as any}
                    onLogout={handleLogout}
                  />
                </ErrorBoundary>
              )}
              {activeTab === 'reports' && (
                <ErrorBoundary>
                  <ReportsScreen
                    onNavigate={handleNavigate as any}
                    onLogout={handleLogout}
                  />
                </ErrorBoundary>
              )}
              {activeTab === 'security' && (
                <ErrorBoundary>
                  <SecurityScannerPage
                    onNavigate={handleNavigate as any}
                    onLogout={handleLogout}
                  />
                </ErrorBoundary>
              )}
              {activeTab === 'settings' && (
                <ErrorBoundary>
                  <Settings
                    onNavigate={handleNavigate as any}
                    onLogout={handleLogout}
                  />
                </ErrorBoundary>
              )}
            </WebSocketProvider>
          ) : (
            <ErrorBoundary>
              <Auth onLogin={handleLogin} />
            </ErrorBoundary>
          )}
        </Suspense>
      </div>
    </ErrorBoundary>
  )
}

export default App
